export const PJM_TZ = 'America/New_York';
export const MAX_GENERATORS_AMOUNT = 10;
